import { Component, Input } from '@angular/core';
import { PATHS } from 'models/bary-paths.model';

@Component({
  selector: 'jhi-bary-sidebar-footer',
  templateUrl: './bary-sidebar-footer.component.html',
  styleUrls: ['./bary-sidebar-footer.component.scss'],
})
export class BarySidebarFooterComponent {
  @Input() isModerator = false;
  PATHS = PATHS;

  callSupport(): void {
    window!.top!.location.href = 'mailto:assistance@bary.app';
  }
}
